import React, { Component } from 'react'
import Checkbox, { CheckboxOption } from 'atpjs/components/form/checkbox'
import Radio, { RadioOption } from 'atpjs/components/form/radio'

class BigOptionContent extends Component {
  state = {
    visible: false
  }

  onMouseOver = (_event) => {
    this.setState({ visible: true })
  }

  onMouseOut = (_event) => {
    this.setState({ visible: false })
  }

  onClick = (event) => {
    event.preventDefault()
    event.stopPropagation()
    this.setState({ visible: true })
    document.addEventListener('click', this.onClickOut)
  }

  onClickOut = (_event) => {
    this.setState({ visible: false })
    document.removeEventListener('click', this.onClickOut)
  }

  render() {
    const {
      label,
      info,
      optionLabelClassName,
      optionSpanClassName,
      optionInfoClassName,
      labelClassName,
      tooltipTitle,
      tooltipContent,
      icon,
      id,
      children
    } = this.props
    const { visible } = this.state
    return (
      <div className={`atp-big-option atp-big-option--${icon}`}>
        <label className={`${optionLabelClassName} ${labelClassName || ''}`}>
          <span className="atp-big-option__icon"></span>
          {children}{' '}
          <span id={`${id}-label`} className={optionSpanClassName}>
            {label}
          </span>
          {info && (
            <span id={`${id}-info`} className={optionInfoClassName}>
              {info}
            </span>
          )}
        </label>
        {tooltipTitle && (
          <span
            className={`atp-big-option__tooltip${visible ? ' atp-big-option__tooltip--visible' : ''}`}
            onMouseOver={this.onMouseOver}
            onMouseOut={this.onMouseOut}>
            <span className="atp-big-option__tooltip__icon" onClick={this.onClick}></span>
            <span className="atp-big-option__tooltip__wrapper">
              <span className="atp-big-option__tooltip__title">{tooltipTitle}</span>
              <span className="atp-big-option__tooltip__content">{tooltipContent}</span>
            </span>
          </span>
        )}
      </div>
    )
  }
}

export class CustomRadioOption extends RadioOption {
  render() {
    return (
      <BigOptionContent {...this.props} id={this.id()}>
        {this.formField()}
      </BigOptionContent>
    )
  }
}

export class CustomCheckboxOption extends CheckboxOption {
  render() {
    return (
      <BigOptionContent {...this.props} id={this.id()}>
        {this.formField()}
      </BigOptionContent>
    )
  }
}

export class BigOptionRadio extends Radio {
  static defaultProps = {
    ...Radio.defaultProps,
    OptionComponent: CustomRadioOption,
    wrapperClassName: 'atp-big-options',
    direction: 'horizontal'
  }
}

export class BigOptionCheckbox extends Checkbox {
  static defaultProps = {
    ...Checkbox.defaultProps,
    OptionComponent: CustomCheckboxOption,
    wrapperClassName: 'atp-big-options',
    // wrapperClassName: 'atp-big-options atp-big-options--two-columns', <- NOTE: it's ready, but we should not use it
    direction: 'horizontal'
  }
}
